module.exports = __webpack_public_path__ + "static/media/img-03.ed5290a5.jpg";